import * as React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.5 22.5h-5v-13h5zm9-9a2 2 0 0 0-2 2v7h-5v-13h5v1.485a6.307 6.307 0 0 1 3.99-1.495c2.962 0 5.01 2.2 5.01 6.355V22.5h-5v-7a2 2 0 0 0-2-2zM6.5 5A2.5 2.5 0 1 1 4 2.5 2.5 2.5 0 0 1 6.5 5z",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgShareLinkedin = function SvgShareLinkedin() {
  return _ref;
};

export default SvgShareLinkedin;